import { useContext, useEffect } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ThankyouBundleStyles as classes } from './ThankyouBundleStyles';
import ThankyouTick from '../../images/group_769.png';
import SupportIcon from '../../images/groupInfo.svg';
import { clearContext } from '../clearContext';
import { clearDoChecklistContext } from '../CommercialDeposit/DragDropFiles/DocLabelTypes';
import { getAccessToken } from '../../services/tokenService';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import {
  APPLICATION_REVIEWED,
  ORIENTAL_BANK,
  RECEIVE_ACCOUNTS_DETAILS,
  WHAT_COME_NEXT,
} from '../../constants';

const ThankyouBundle = (props) => {
  const { history } = props;
  const { t } = useTranslation();
  const leadGenerationSubmission = useContext(LeadGenerationContext);
  const { theme } = leadGenerationSubmission;

  useEffect(() => {
    leadGenerationSubmission.setCurrentPage('thank-you-bundle');
    leadGenerationSubmission.pauseTimerAndClearInterval();
    leadGenerationSubmission.clearPingTimer();
  }, []);

  const POP_ACTION = 'POP';
  const DEV = 'development';

  useEffect(() => {
    let unListenSubmission = null;
    unListenSubmission = history.listen(() => {
      if (history.action === POP_ACTION) {
        if (process.env.REACT_APP_ENVIRONMENT === DEV) {
          clearContext(leadGenerationSubmission);
          clearDoChecklistContext(leadGenerationSubmission);

          history.push('/');
        } else {
          let url = '';
          if (leadGenerationSubmission.location === 'PR') {
            url = `https://orientalbank.com/${leadGenerationSubmission.language?.toLowerCase()}`;
          } else if (leadGenerationSubmission.location === 'VI') {
            url = `https://orientalbank.com/${leadGenerationSubmission.language?.toLowerCase()}/${leadGenerationSubmission.location?.toLowerCase()}`;
          } else {
            url = `https://orientalbank.com/`;
          }
          window.location.href = url;
        }
      }
    });
    return unListenSubmission;
  }, []);

  const handleRoute = async () => {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      clearContext(leadGenerationSubmission);
      clearDoChecklistContext(leadGenerationSubmission);

      const token = await getAccessToken();
      if (token) {
        leadGenerationSubmission.setAccessToken(token);
        leadGenerationSubmission.pingTimer(token);
        leadGenerationSubmission.startTimer();
        history.push('/');
      }
    } else {
      let url = '';
      if (leadGenerationSubmission.isQR) {
        url = `https://orientalbank2016.sharepoint.com/sites/OrientalIntranet/SitePages/External-web-links.aspx`;
      } else if (leadGenerationSubmission.location === 'PR') {
        url = `https://orientalbank.com/${leadGenerationSubmission.language?.toLowerCase()}`;
      } else if (leadGenerationSubmission.location === 'VI') {
        url = `https://orientalbank.com/${leadGenerationSubmission.language?.toLowerCase()}/${leadGenerationSubmission.location?.toLowerCase()}`;
      } else {
        url = `https://orientalbank.com/`;
      }
      window.location.href = url;
    }
  };

  return (
    <Box component="div" sx={classes.mainContainer}>
      <Grid container sx={classes.thankyouGrid}>
        <Grid size={{ sx: 12, sm: 12, md: 12, lg: 12 }} sx={classes.sectionContainer1}>
          <Box
            component="img"
            src={ThankyouTick}
            width="86px"
            height="86px"
            alt={t('Profile picture')}
          />

          <Typography
            component="h1"
            variant="largeHeading"
            sx={{ ...classes.text1, color: theme?.palette?.primary?.main }}
          >
            {t('You are almost done', {
              defaultValue: 'You are almost done',
            })}
            <Box component="div">
              {t('with the opening process.', { defaultValue: 'with the opening process.' })}
            </Box>
          </Typography>
        </Grid>

        <Grid size={{ sx: 12, sm: 12, md: 12, lg: 12 }} sx={classes.sectionContainer2}>
          <Typography component="h5" variant="h5" sx={classes.text2}>
            {t(WHAT_COME_NEXT, {
              defaultValue: WHAT_COME_NEXT,
            })}
          </Typography>
          <Box component="div" sx={classes.iconGrid}>
            <Box
              component="img"
              src={SupportIcon}
              width="24px"
              height="24px"
              alt="Submission Success"
            />
            <Typography component="p" variant="subtitle1" sx={classes.iconGridText}>
              {t(APPLICATION_REVIEWED, {
                defaultValue: APPLICATION_REVIEWED,
              })}
            </Typography>
          </Box>
          <Box component="div" sx={classes.iconGrid}>
            <Box
              component="img"
              src={SupportIcon}
              width="24px"
              height="24px"
              alt="Submission Success"
            />
            <Typography
              component="p"
              variant="subtitle1"
              sx={{
                ...classes.iconGridText,
                color: theme?.palette?.primary?.main,
                whiteSpace: 'pre-line',
              }}
            >
              {t(RECEIVE_ACCOUNTS_DETAILS, {
                defaultValue: RECEIVE_ACCOUNTS_DETAILS,
              })}
            </Typography>
          </Box>
        </Grid>

        <Button
          disableFocusRipple
          sx={{
            ...classes.bankingButton,
            backgroundColor: theme?.palette?.orientalPrimary?.main,
            color: theme?.palette?.secondary?.main,
          }}
          data-testid="ReturnToOrientalButtonTitle"
          onClick={handleRoute}
        >
          {t(ORIENTAL_BANK, { defaultValue: ORIENTAL_BANK })}
        </Button>
      </Grid>
    </Box>
  );
};

export default withRouter(ThankyouBundle);
ThankyouBundle.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    listen: PropTypes.func,
    action: PropTypes.string,
  }),
};
